import { handleActions } from 'redux-actions'
import { clearDetailSearchCriteria, clearQuickSearchCriteria, setDetailSearchCriteria, setQuickSearchCriteria } from './actions'

export const initialState = {
    /** @type {{ search: string } | null} */
    quickSearchCriteria: null,
    /** @type {{ searchType: string, criteria: Record<string, unknown> } | null} */
    detailSearchCriteria: null,
}

export default handleActions(
    {
        [setQuickSearchCriteria]: (state, { payload }) => ({
            ...state,
            quickSearchCriteria: payload?.searchProps ?? null,
        }),
        [clearQuickSearchCriteria]: (state) => ({
            ...state,
            quickSearchCriteria: null,
        }),
        [setDetailSearchCriteria]: (state, { payload }) => {
            const { searchType, criteria } = payload

            return {
                ...state,
                detailSearchCriteria: { searchType, criteria },
            }
        },
        [clearDetailSearchCriteria]: (state, { payload }) => {
            const { searchType } = payload

            // Only clear if the stored criteria actually belongs to this type
            if (state.detailSearchCriteria?.searchType !== searchType) {
                return state
            }

            return {
                ...state,
                detailSearchCriteria: null,
            }
        },
    },
    initialState
)
